import { render, staticRenderFns } from "./VideoPlayerNew.vue?vue&type=template&id=59ededa8"
import script from "./VideoPlayerNew.vue?vue&type=script&lang=ts"
export * from "./VideoPlayerNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ededa8')) {
      api.createRecord('59ededa8', component.options)
    } else {
      api.reload('59ededa8', component.options)
    }
    module.hot.accept("./VideoPlayerNew.vue?vue&type=template&id=59ededa8", function () {
      api.rerender('59ededa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/VideoPlayerNew.vue"
export default component.exports